import logo2005 from "../../assets/img/historicEvents/LogoNYR/2005.png";
import logo2006 from "../../assets/img/historicEvents/LogoNYR/2006.png";
import logo2007 from "../../assets/img/historicEvents/LogoNYR/2007.png";
import logo2024 from "../../assets/img/historicEvents/LogoNYR/2024.png";

export const newYearsRevolutionDetail = {
  "new-years-revolution": {
    id: "new-years-revolution",
    title: "New Year's Revolution",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "new-years-revolution",
        items: [
          {
            id: "new-years-revolution-2005",
            title: "New Year's Revolution",
            description: "2005",
            imgUrl: logo2005,
          },
          {
            id: "new-years-revolution-2006",
            title: "New Year's Revolution",
            description: "The Elimination Chamber; 10 Tons of Steel. 2 Miles of Chain. One Man Left Standing. 2006",
            imgUrl: logo2006,
          },
          {
            id: "new-years-revolution-2007",
            title: "New Year's Revolution",
            description: "The Revolution Continues… 2007",
            imgUrl: logo2007,
          },
          {
            id: "new-years-revolution-2024",
            title: "SmackDown",
            description: "New Year's Revolution 2024",
            imgUrl: logo2024,
          },
        ],
      },
    ],
  },
};
